import React from 'react';
import '../styles/Experience.css';

const Experience = () => {
  const experiences = [
    {
      company: 'Telnova Solutions',
      position: 'AI Engineer (Full-Time)',
      duration: 'Jan 2026 - Present',
      description: [
        'Designed and deployed end-to-end AI systems combining computer vision, LLM-based agents, and automation pipelines.',
        'Built a production-grade AI voice call-center platform using LiveKit, Gemini Realtime API, Qdrant, Redis, and FastAPI.',
        'Implemented RAG pipelines with vector search for company knowledge bases.',
        'Developed semantic caching to reduce latency and API cost in LLM applications.',
        'Integrated session recording, transcript generation, and helpdesk ticket creation via Frappe Helpdesk APIs.',
        'Trained and deployed YOLO-based models for PPE detection and kitchen hygiene monitoring with Frigate NVR.'
      ],
      technologies: ['LiveKit', 'Gemini API', 'Qdrant', 'Redis', 'FastAPI', 'YOLO', 'Frigate']
    },
    {
      company: 'National Telecommunication Institute (NTI)',
      position: 'Advanced AI and Computer Vision Intern',
      duration: 'Oct 2025 - Dec 2025',
      description: [
        'Implemented computer vision pipelines for segmentation, detection, and inpainting using SAM2.',
        'Built deep learning architectures including U-Net, ResNet, GANs, and DCGANs using PyTorch.',
        'Developed generative AI pipelines for text-to-image and image-to-video tasks.',
        'Built Arabic NLP pipelines including data scraping, embeddings, and transformer training.'
      ],
      technologies: ['PyTorch', 'SAM2', 'GANs', 'NLP', 'Transformers']
    },
    {
      company: 'Electronics Research Institute (ERI)',
      position: 'AI Engineer Intern',
      duration: 'Jul 2023 - Aug 2023',
      description: [
        'Implemented optimized A* pathfinding algorithm reducing computation time by 30%.',
        'Applied ML and deep learning techniques in a research environment.'
      ],
      technologies: ['Python', 'Algorithm Optimization', 'Robotics']
    }
  ];

  const achievements = [
    {
      title: 'Favikon 2025',
      description: 'Ranked #2 in AI Research and Innovation in Egypt and #1539 overall in Egypt for professional presence and impact.'
    },
    {
      title: 'Google Developer Student Club (GDSC)',
      description: 'Founder & Lead (2022-2023), Team Member (2021-2022)',
      achievements: [
        'Organized 12+ AI workshops attended by over 300 students',
        'Managed a 25-member technical team',
        'Secured partnerships for training initiatives'
      ]
    }
  ];

  const education = [
    {
      institution: 'Faculty of Engineering - Helwan University',
      degree: 'Bachelor of Science (B.Sc.) in Electronics and Communications Engineering',
      duration: '09/2020 - 07/2025',
      gpa: '70% (Good)',
      coursework: 'Machine Learning, Digital Signal Processing, Probability & Statistics, Neural Networks, Advanced Algorithms'
    }
  ];

  return (
    <section className="experience" id="experience">
      <div className="container">
        <h2>Experience & Education</h2>

        <div className="experience-section">
          <h3>Work Experience</h3>
          <div className="timeline">
            {experiences.map((exp, index) => (
              <div key={index} className="timeline-item">
                <div className="timeline-marker"></div>
                <div className="timeline-content">
                  <div className="experience-header">
                    <h4>{exp.position}</h4>
                    <span className="company">{exp.company}</span>
                    <span className="duration">{exp.duration}</span>
                  </div>
                  <ul className="experience-description">
                    {exp.description.map((item, itemIndex) => (
                      <li key={itemIndex}>{item}</li>
                    ))}
                  </ul>
                  <div className="experience-technologies">
                    {exp.technologies.map((tech, techIndex) => (
                      <span key={techIndex} className="tech-tag">{tech}</span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="achievements-section">
          <h3>Leadership & Achievements</h3>
          <div className="achievements-list">
            {achievements.map((achievement, index) => (
              <div key={index} className="achievement-item">
                <h4>{achievement.title}</h4>
                <p>{achievement.description}</p>
                {achievement.achievements && (
                  <ul>
                    {achievement.achievements.map((item, itemIndex) => (
                      <li key={itemIndex}>{item}</li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
          </div>
        </div>

        <div className="education-section">
          <h3>Education</h3>
          <div className="education-list">
            {education.map((edu, index) => (
              <div key={index} className="education-item">
                <h4>{edu.degree}</h4>
                <span className="institution">{edu.institution}</span>
                <span className="duration">{edu.duration}</span>
                <p><strong>GPA:</strong> {edu.gpa}</p>
                <p><strong>Relevant Coursework:</strong> {edu.coursework}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;
